import React, { createContext, useCallback, useEffect, useState } from "react";
import { patientApi } from "../utils/patientApi";

export const PatientAuthContext = createContext({
  patient: null,
  isLoading: true,
  login: () => {},
  logout: () => {},
  refreshPatient: () => {},
});

export const PatientAuthProvider = ({ children }) => {
  const [patient, setPatient] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const saveSession = useCallback((data) => {
    if (data.accessToken) localStorage.setItem("patientAccessToken", data.accessToken);
    if (data.refreshToken) localStorage.setItem("patientRefreshToken", data.refreshToken);
    if (data.patient) setPatient(data.patient);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("patientAccessToken");
    localStorage.removeItem("patientRefreshToken");
    setPatient(null);
  }, []);

  const refreshPatient = useCallback(async () => {
    try {
      const data = await patientApi.me();
      if (data.patient) {
        setPatient(data.patient);
        if (data.accessToken) localStorage.setItem("patientAccessToken", data.accessToken);
        if (data.refreshToken) localStorage.setItem("patientRefreshToken", data.refreshToken);
      }
    } catch {
      logout();
    }
  }, [logout]);

  // On mount: rehydrate session if tokens exist
  useEffect(() => {
    const token = localStorage.getItem("patientAccessToken");
    const refresh = localStorage.getItem("patientRefreshToken");
    if (!token && !refresh) {
      setIsLoading(false);
      return;
    }
    refreshPatient().finally(() => setIsLoading(false));
  }, [refreshPatient]);

  return (
    <PatientAuthContext.Provider value={{ patient, isLoading, login: saveSession, logout, refreshPatient }}>
      {children}
    </PatientAuthContext.Provider>
  );
};
